import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, inject } from "@angular/core";
import { DataService } from "../service/data.service";
import { IBucketItem } from "../models/bucket-item.model";
import {
  AppSettingsService,
  OverlayPopupService,
  SpinnerService,
} from "../../../core";
import { PackageOverlayComponent } from "../package-overlay/package-overlay.component";
import { FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IBucketItemRequest } from "../models/bucket-item-request.model";
import { IBreadcrumbItem } from "../../../main/layout/tool-bar/model/breadcrumb.model";
import { IBucketItemTransferRequest } from "../models/bucket-item-transfer.model";
import { BucketItemService } from "../service/bucket-item.service";
import { Subscription, catchError, map, tap, throwError } from "rxjs";
import { MessageService } from "../../../main";
import { IBucketToTransfer } from "../models/bucket-to-transfer.model";
import { BucketsService } from "../../buckets/service/buckets.service";
import { BreadcrumbDataService } from "../../../main/layout/tool-bar/breadcrumb-service/breadcrumb-data.service";
import { MatDialog } from "@angular/material/dialog";
import { DateMismatchTableDialogComponent } from "./date-mismatch-table-dialog/date-mismatch-table-dialog.component";
import { TagMismatchTableDialogComponent } from "./tag-mismatch-table-dialog/tag-mismatch-table-dialog.component";
import { ITransferPackageResponse } from "../models/transfer-package-response";
import { IDestinationBucketListRequest } from "../models/destination-bucket-list-request.model";
import { ErrorConstants, DialogConfig } from "../constants/component-constants";
import { JustificationDialogComponent } from "../../../shared/justification-dialog/justification-dialog.component";
import { MatChipListbox, MatChipOption, MatChipRemove } from "@angular/material/chips";
import { TooltipDisableDirective } from "../../../shared/custom-directives/tooltip.directive";
import { MatIcon } from "@angular/material/icon";
import { MatError, MatFormField, MatLabel } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatTooltip } from "@angular/material/tooltip";
import { MatOption } from "@angular/material/autocomplete";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-transfer-items",
    templateUrl: "./transfer-items.component.html",
    styleUrls: ["./transfer-items.component.scss"],
    imports: [MatChipListbox, MatChipOption, TooltipDisableDirective, MatChipRemove, MatIcon, MatError, FormsModule, MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatTooltip, MatOption, MatButton]
})
export class TransferItemsComponent implements OnInit, OnDestroy {
  private dataService = inject(DataService);
  private readonly overlayPopupService = inject(OverlayPopupService);
  private fb = inject(FormBuilder);
  private bucketItemService = inject(BucketItemService);
  private messageService = inject(MessageService);
  private appSettingService = inject(AppSettingsService);
  private breadcrumbDataService = inject(BreadcrumbDataService);
  private bucketService = inject(BucketsService);
  private dialog = inject(MatDialog);
  private spinnerService = inject(SpinnerService);

  @ViewChild("chipList") chipList: { errorState: boolean };
  public items: Partial<IMismatchPackageFolderList>[] = [];
  @Output() cancelTransfer = new EventEmitter<boolean>();
  @Output() getAllBucketItemsRequest = new EventEmitter<Partial<IBucketItemRequest>>();
  packagefolder: Partial<IBucketItem>[] = [];
  public requestData: IBucketItemTransferRequest;
  limitedpackagefolder: Partial<IBucketItem>[] = [];
  public DestinationPackageFolder = new FormControl("", [Validators.required]);
  public parentData: Partial<IBreadcrumbItem>;
  public bucketName: string="";
  public form = this.fb.group({
    DestinationPackageFolder: this.DestinationPackageFolder,
  });

  public currentBreadcrumbItem: IBreadcrumbItem = null;
  public transferListOptions: Partial<IBucketToTransfer>[] = [];
  public destionationBucketListRequest: IDestinationBucketListRequest;
  public dataSubscription: Subscription;
  private readonly featureToken = "bucket-items";
  private readonly surfaceToken = "transfer-items";

  ngOnInit(): void {
    this.breadcrumbDataService.selectedBreadcrumb$
      .pipe(
        tap((item: IBreadcrumbItem) => {
          this.currentBreadcrumbItem = item;
        })
      )
      .subscribe();
    this.dataSubscription = this.dataService
      .getAllSelectedData()
      .subscribe((data: Partial<IBucketItem>[]) => {
        if (data != null) {
          this.packagefolder = [...data];

          this.maintainlimitedpackagefolderlist();
          if (this.packagefolder?.length > 0 && this.chipList) {
            this.chipList.errorState = false;
          }
        }
      });
      this.DestinationPackageFolder.valueChanges.subscribe(x=>{
        let name=this.transferListOptions.find(y=>y.BucketId===x);
        this.bucketName=name.BUCode + " " + name.BucketName + " " + name.Description;
      })
      }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  remove(packageitem: Partial<IBucketItem>): void {
    const index = this.packagefolder.indexOf(packageitem);
    if (index >= 0) {
      this.packagefolder.splice(index, 1);
    }
    this.dataService.setDataForCheckBox(this.packagefolder);
    this.maintainlimitedpackagefolderlist();
  }

  stringlength(packagefolder: Partial<IBucketItem>[]): boolean {
    if (packagefolder.length > 6) {
      return true;
    }
    return false;
  }

  overlaydisplay(packagefolder: [], e: any) {
    this.overlayPopupService.open(PackageOverlayComponent, {
      data: packagefolder,
      element: e,
      displayPointer: true,
    });
  }

  maintainlimitedpackagefolderlist() {
    var studyCodes: string[] = [];
    this.packagefolder.forEach((x) => {
      studyCodes.push(x.LeafName);
    });

    this.getDestinationDropDown(studyCodes);
    if (this.packagefolder.length > 6) {
      this.limitedpackagefolder = this.packagefolder.slice(0, 6);
    } else {
      this.limitedpackagefolder = [...this.packagefolder];
    }
  }

  cancel() {
    this.cancelTransfer.emit(true);
  }

  transferPackageOnSubmit() {
    if (this.packagefolder?.length === 0) {
      this.chipList.errorState = true;
    }
    this.DestinationPackageFolder.markAsTouched();
    let selectedDestination = this.transferListOptions.filter(
      (x) => x.BucketId === this.DestinationPackageFolder.value
    )[0];
    this.requestData = {...this.requestData,
      SourceBucketId: this.currentBreadcrumbItem.BucketId,
      SourceBucketType: this.currentBreadcrumbItem.BucketType,
      SourceBUCode: this.currentBreadcrumbItem.BUCode,
      PackageFolderIds: [...this.packagefolder.map((x) => x.Id)],
      DestinationBucketId: selectedDestination.BucketId,
      DestinationBUCode: selectedDestination.BUCode,
      DestinationBucketType: selectedDestination.BucketType,
    };
    if (this.requestData.PackageFolderIds.length > 0) {
      this.spinnerService.show(true);
      this.bucketItemService
        .TransferPackage(this.requestData)
        .pipe(
          map((res: Partial<ITransferPackageResponse>) => {
            if (res) {
              this.spinnerService.show(false);
              if(res.JustificationRequired){
                this.dialog.open(JustificationDialogComponent,{
                  width:"450px",
                  disableClose:true
                }).afterClosed().subscribe(
                  (response: {comment:string})=>{
                    if(response && response.comment){
                      this.requestData.Comment = response.comment;
                      //It will make the process continue after giving the justification
                      this.transferPackageOnSubmit();
                    }
                  }
                );
              }else{
                const failedCount = (res.MismatchedPackageFolders?.length || 0) + (res.TagMismatchedPackageFolders?.length || 0);
                const hasSuccessfulTransfer = this.requestData.PackageFolderIds.length > failedCount;
                
                if (hasSuccessfulTransfer) {
                  this.messageService.success(
                    "Package Folder(s)  transferred successfully",
                    this.appSettingService.toastrDisplayTime
                  );
                  this.getAllBucketItemsRequest.emit(this.currentBreadcrumbItem);
                }
                if(res.IsMalicious)
                {
                  this.messageService.warning(
                    ErrorConstants.MALICIOUS_WARNING,
                    this.appSettingService.toastrDisplayTime
                  );
                }
                
                if (res.HasTagMismatch && res.TagMismatchedPackageFolders && res.TagMismatchedPackageFolders.length > 0) {
                  this.openTagMismatchTableDialog(res.TagMismatchedPackageFolders);
                } else if (!res.IsAllFolderTransferred && res.MismatchedPackageFolders?.length > 0) {
                  this.items = [...res.MismatchedPackageFolders];
                  this.openDateMismatchTableDialog();
                }
              }
            }
          }),
          catchError((error: any) => {
            this.spinnerService.show(false);
            if (
              error.error.detail ===
              "Transfer failed, Study Completion Date is not available"
            ) {
              this.messageService.alert(
                error.error.detail,
                this.appSettingService.toastrDisplayTime
              );
              this.dataService.setPackageFolders([
                ...this.requestData.PackageFolderIds,
              ]);
              this.highlightPackageFolderWithoutSCD();
            } else if (error.error.detail !== undefined) {
              this.messageService.alert(
                error.error.detail,
                this.appSettingService.toastrDisplayTime
              );
            } else {
              this.messageService.alert(
                "Transfer failed, please try again",
                this.appSettingService.toastrDisplayTime
              );
            }
            return throwError(() => {
              new Error(error.message);
            });
          })
        )
        .subscribe();
    }
  }

  public getDestinationDropDown(studyCodes: string[]): void {
    this.destionationBucketListRequest = {
      BUCode: this.currentBreadcrumbItem.BUCode,
      BucketType: this.currentBreadcrumbItem.BucketType,
      StudyCodes: studyCodes,
    };
    this.bucketService
      .GetDestinationDataForTransfer(this.destionationBucketListRequest)
      .pipe(
        map((result: Partial<IBucketToTransfer>[]) => {

          if (result && result.length > 0) {
            this.transferListOptions = [...result];
            if (this.transferListOptions.length === 1) {
              this.form.controls.DestinationPackageFolder.setValue(
                this.transferListOptions[0].BucketId
              );
              this.bucketName=this.transferListOptions[0].BUCode + " " + this.transferListOptions[0].BucketName + " " + this.transferListOptions[0].Description;
            }
          }

          if (this.packagefolder && this.packagefolder.length === 0) {
            this.transferListOptions = null;
            this.form.controls.DestinationPackageFolder.reset();
          }
        }),
        catchError((error: any) => {
          this.spinnerService.show(false);
          if (
            error?.error?.detail === ErrorConstants.DO_NOT_HAVE_STUDY_ACCESS
          ) {
            this.form.controls.DestinationPackageFolder.markAsTouched();
            this.form.controls.DestinationPackageFolder.setErrors({
              doesNotHaveStudyAccess: true,
            });
            this.transferListOptions = null;
          } else if (
            error?.error?.detail === ErrorConstants.YOU_DO_NOT_HAVE_ACCESS_TO_PREARCHIVE_BUCKET_TO_TRANSFER
          ) {
            this.form.controls.DestinationPackageFolder.markAsTouched();
            this.form.controls.DestinationPackageFolder.setErrors({
              doesNotHavePreArchiveBricsAccess: true,
            });
            this.transferListOptions = null;
          } else if (
            error?.error?.detail === ErrorConstants.PLEASE_SELECT_STUDY_PACKAGE_FOLDERS_FROM_SAME_BU
          ) {
            this.form.controls.DestinationPackageFolder.markAsTouched();
            this.form.controls.DestinationPackageFolder.setErrors({
              studiesNotFromSameBU: true,
            });
            this.transferListOptions = null;
          } else if (
            error?.error?.detail === ErrorConstants.STUDY_NOT_MAPPED_TO_BU
          ) {
            this.form.controls.DestinationPackageFolder.markAsTouched();
            this.form.controls.DestinationPackageFolder.setErrors({
              studyNotMappedToBu: true,
            });
            this.transferListOptions = null;
          }else if (error.error.detail !== undefined) {
            this.messageService.alert(
              error.error.detail,
              this.appSettingService.toastrDisplayTime
            );
          } else {
            this.messageService.alert(
              "Transfer failed, please try again",
              this.appSettingService.toastrDisplayTime
            );
          }
          return throwError(() => {
            new Error(error.message);
          });
        })
      )
      .subscribe();
  }

  openDateMismatchTableDialog(): void {
    let height;
    if (this.items.length === 1) {
      height = "320px";
    } else if (this.items.length === 2) {
      height = "400px";
    } else {
      height = "550px";
    }
    let dialogRef = this.dialog.open(DateMismatchTableDialogComponent, {
      width: "529px",
      maxHeight: height,
      data: this.items,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.dataService.setDataForCheckBox(this.packagefolder);
    });
  }

  openTagMismatchTableDialog(tagMismatchedFolders: any[]): void {
    const config = DialogConfig.TAG_MISMATCH;
    const totalTags = tagMismatchedFolders.reduce((sum, folder) => sum + folder.MismatchedTags.length, 0);
    let height = config.HEIGHT.LARGE;
    
    if (totalTags <= config.THRESHOLDS.SMALL) {
      height = config.HEIGHT.SMALL;
    } else if (totalTags <= config.THRESHOLDS.MEDIUM) {
      height = config.HEIGHT.MEDIUM;
    }
    
    this.dialog.open(TagMismatchTableDialogComponent, {
      width: config.WIDTH,
      maxHeight: height,
      data: tagMismatchedFolders,
      disableClose: true,
    });
  }

  highlightPackageFolderWithoutSCD(): void {
    this.packagefolder.forEach((x) => {
      x.IsConsideredForTransfer = x.StudyCompletionDate ? false : true;
    });
  }

  public buildControlId(element: string, context?: string | number): string {
    const tokens = [
      this.featureToken,
      this.surfaceToken,
      this.slugify(element),
    ];
    if (context !== undefined && context !== null) {
      tokens.push(this.formatContextToken(context));
    }
    return tokens.join("-");
  }

  private formatContextToken(value: string | number): string {
    if (typeof value === "number") {
      return value.toString().padStart(2, "0");
    }
    if (typeof value === "string" && value.trim().length > 0) {
      return this.slugify(value);
    }
    return "00";
  }

  private slugify(value: string): string {
    return (value || "na")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-{2,}/g, "-");
  }
}

export interface IMismatchPackageFolderList {
  PackageFolderId: string;
  FolderName: string;
  SourceBucketDate: string;
  DestinationBucketDate: string;
  ChecksumStatus: string;
}
